import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles/$roleId/users')(
  {
    component: lazyRouteComponent(() => import('@/components/AccessManagement/RoleUsers'), 'RoleIdUsersComponent'),
    pendingComponent: lazyRouteComponent(() => import('@/components/AccessManagement/UsersSkeleton'), 'UsersSkeleton'),
  },
);
